module.exports = __webpack_public_path__ + "img/img4.bc2d6e6a.jpg";